import { axiosInstance } from "../config/axiosInstance";

//veri modeli
export interface TollnerSepsisRecord {
  id: number;
  date: string;
  createdBy?: string;
  skinColorChange: string;
  peripheralCirculation: string;
  hypotonia: string;
  bradycardia: string;
  apnea: string;
  respiratoryDistress: string;
  hepatomegaly: string;
  gastrointestinalFinding: string;
  leukocyteCount: string;
  leftShift: string;
  thrombocytopenia: string;
  metabolicAcidosis: string;
  score: number;
  sepsisStatus: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TollnerSepsisFormData {
    date: Date | null;
    createdBy?: string;
    skinColorChange?: string;
    peripheralCirculation?: string;
    hypotonia?: string;
    bradycardia?: string;
    apnea?: string;
    respiratoryDistress?: string;
    hepatomegaly?: string;
    gastrointestinalFinding?: string;
    leukocyteCount?: string;
    leftShift?: string;
    thrombocytopenia?: string;
    metabolicAcidosis?: string;
    totalScore?: number;
    sepsisStatus?: string;
  }

//projede olabilir. sormam gerekiyor.
interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

interface DeleteResponse {
  success: boolean;
  id: number;
}

// deneme verileri. gerçek api yok
const mockTollnerSepsisData: TollnerSepsisRecord[] = [
  {
    id: 1,
    date: "14.04.2025 10:30",
    skinColorChange: "Yok",
    peripheralCirculation: "Yok",
    hypotonia: "Yok",
    bradycardia: "Yok",
    apnea: "Yok",
    respiratoryDistress: "Var",
    hepatomegaly: "Yok",
    gastrointestinalFinding: "Yok",
    leukocyteCount: "Normal",
    leftShift: "Yok",
    thrombocytopenia: "Yok",
    metabolicAcidosis: "Yok",
    score: 2,
    sepsisStatus: "Sepsis Yok",
  },
  {
    id: 2,
    date: "13.04.2025 14:15",
    skinColorChange: "Belirgin",
    peripheralCirculation: "Orta",
    hypotonia: "Orta",
    bradycardia: "Var",
    apnea: "Var",
    respiratoryDistress: "Var",
    hepatomegaly: "> 4cm",
    gastrointestinalFinding: "Var",
    leukocyteCount: "Lökositoz",
    leftShift: "Orta",
    thrombocytopenia: "Var",
    metabolicAcidosis: ">7.2",
    score: 9,
    sepsisStatus: "Sepsis Olasılığı",
  },
  {
    id: 3,
    date: "12.04.2025 09:00",
    skinColorChange: "Belirgin",
    peripheralCirculation: "Belirgin",
    hypotonia: "Belirgin",
    bradycardia: "Var",
    apnea: "Var",
    respiratoryDistress: "Var",
    hepatomegaly: "> 4cm",
    gastrointestinalFinding: "Var",
    leukocyteCount: "Lökopeni",
    leftShift: "Belirgin",
    thrombocytopenia: "Var",
    metabolicAcidosis: "<7.2",
    score: 14,
    sepsisStatus: "Sepsis Teşhisi",
  },
];

export const tollnerSepsisService = {
  createTollnerSepsis: async (data: TollnerSepsisFormData): Promise<TollnerSepsisRecord> => {
    try {
      //simülasyon
      console.log("Creating Töllner Sepsis record with data:", data);
      
      // api gecikmesi simüle
      await new Promise(resolve => setTimeout(resolve, 500));
      
      return {
        id: Math.floor(Math.random() * 1000) + 10,
        date: data.date ? new Date(data.date).toLocaleString() : new Date().toLocaleString(),
        skinColorChange: data.skinColorChange || "Yok",
        peripheralCirculation: data.peripheralCirculation || "Yok",
        hypotonia: data.hypotonia || "Yok",
        bradycardia: data.bradycardia || "Yok",
        apnea: data.apnea || "Yok",
        respiratoryDistress: data.respiratoryDistress || "Yok",
        hepatomegaly: data.hepatomegaly || "Yok",
        gastrointestinalFinding: data.gastrointestinalFinding || "Yok",
        leukocyteCount: data.leukocyteCount || "Normal",
        leftShift: data.leftShift || "Yok",
        thrombocytopenia: data.thrombocytopenia || "Yok",
        metabolicAcidosis: data.metabolicAcidosis || "Yok",
        score: data.totalScore || 0,
        sepsisStatus: data.sepsisStatus || "Sepsis Yok",
        createdAt: new Date().toISOString()
      };
      
      // backend hazır olduğunda açılabilir
      /*
      const response = await axiosInstance.post<ApiResponse<TollnerSepsisRecord>>(
        process.env.REACT_APP_API_URL + "/auth/v1/medcard/tollnerSepsisService/Create/V1", 
        { data }
      );
      
      if (response.status === 200) {
        return response.data.DbResponse.Result.Data;
      } else {
        console.log("TollnerSepsis service error!", response);
        throw new Error("Error in create");
      }
      */
    } catch (error) {
      console.log("TollnerSepsis service error!", error);
      throw new Error("Error in create");
    }
  },

  updateTollnerSepsis: async (id: number, data: TollnerSepsisFormData): Promise<TollnerSepsisRecord> => {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      
      console.log(`Updating Töllner Sepsis record #${id} with data:`, data);
      
      // mock veri
      return {
        id,
        date: data.date ? new Date(data.date).toLocaleString() : new Date().toLocaleString(),
        skinColorChange: data.skinColorChange || "Yok",
        peripheralCirculation: data.peripheralCirculation || "Yok",
        hypotonia: data.hypotonia || "Yok",
        bradycardia: data.bradycardia || "Yok",
        apnea: data.apnea || "Yok",
        respiratoryDistress: data.respiratoryDistress || "Yok",
        hepatomegaly: data.hepatomegaly || "Yok",
        gastrointestinalFinding: data.gastrointestinalFinding || "Yok",
        leukocyteCount: data.leukocyteCount || "Normal",
        leftShift: data.leftShift || "Yok",
        thrombocytopenia: data.thrombocytopenia || "Yok",
        metabolicAcidosis: data.metabolicAcidosis || "Yok",
        score: data.totalScore || 0,
        sepsisStatus: data.sepsisStatus || "Sepsis Yok",
        updatedAt: new Date().toISOString()
      };
      
      // backend hazır olduğunda aılabilir ama önce berkaya sormalıyım
      /*
      const response = await axiosInstance.put<ApiResponse<TollnerSepsisRecord>>(
        process.env.REACT_APP_API_URL + "/auth/v1/medcard/tollnerSepsisService/Update/V1",
        { id, data }
      );
      
      if (response.status === 200) {
        return response.data.DbResponse.Result.Data;
      } else {
        console.log("TollnerSepsis service error!", response);
        throw new Error("Error in update");
      }
      */
    } catch (error) {
      console.log("TollnerSepsis service error!", error);
      throw new Error("Error in update");
    }
  },

  deleteTollnerSepsis: async (id: number): Promise<DeleteResponse> => {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      
      console.log(`Deleting Töllner Sepsis record #${id}`);
      
      return { success: true, id };
      
      // baxkend hazır oldığında
      /*
      const response = await axiosInstance.delete<ApiResponse<DeleteResponse>>(
        process.env.REACT_APP_API_URL + "/auth/v1/medcard/tollnerSepsisService/Delete/V1",
        { params: { id } }
      );
      
      if (response.status === 200) {
        return response.data.DbResponse.Result.Data;
      } else {
        console.log("TollnerSepsis service error!", response);
        throw new Error("Error in delete");
      }
      */
    } catch (error) {
      console.log("TollnerSepsis service error!", error);
      throw new Error("Error in delete");
    }
  },

  listTollnerSepsis: async (filters: Record<string, any> = {}): Promise<TollnerSepsisRecord[]> => {
    try {
      await new Promise(resolve => setTimeout(resolve, 700));
      
      console.log("Fetching Töllner Sepsis records with filters:", filters);
      
      // yapay verileri direk dön
      return mockTollnerSepsisData;
      
      // backend geldiğinde açılabilir
      /*
      const response = await axiosInstance.get<ApiResponse<TollnerSepsisRecord[]>>(
        process.env.REACT_APP_API_URL + "/auth/v1/medcard/tollnerSepsisService/List/V1",
        { params: { data: filters } }
      );
      
      if (response.status === 200) {
        return response.data.DbResponse.Result.Data;
      } else {
        console.log("TollnerSepsis service error!", response);
        throw new Error("Error in list");
      }
      */
    } catch (error) {
      console.log("TollnerSepsis service error!", error);
      throw new Error("Error in list");
    }
  },

  getTollnerSepsisById: async (id: number): Promise<TollnerSepsisRecord> => {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      
      console.log(`Fetching Töllner Sepsis record #${id}`);
      
      const record = mockTollnerSepsisData.find(row => row.id === id);
      
      if (!record) {
        throw new Error("Record not found");
      }
      
      return record;
      
      // backend?
      /*
      const response = await axiosInstance.get<ApiResponse<TollnerSepsisRecord>>(
        process.env.REACT_APP_API_URL + "/auth/v1/medcard/tollnerSepsisService/Get/V1",
        { params: { id } }
      );
      
      if (response.status === 200) {
        return response.data.DbResponse.Result.Data;
      } else {
        console.log("TollnerSepsis service error!", response);
        throw new Error("Error in get");
      }
      */
    } catch (error) {
      console.log("TollnerSepsis service error!", error);
      throw new Error("Error in get");
    }
  },
};

export default tollnerSepsisService;